<template>
  <div class="h-100">
    <header-simple />

    <v-row no-gutters class="h-100">
      <v-col cols="12" md="4" sm="6" class="d-flex align-start justify-center login-form-row">
        <div class="form--maxsize">
          <div class="elevation-0 pb-3">
            <div class="page__title" role="region" aria-label="Rejestracja">
              <h1>Rejestracja</h1>

              <title-decoration />
            </div>

            <register-form :schema="$schema" @registerAccount="registerAccount" />
          </div>
        </div>
      </v-col>

      <v-col
        cols="12"
        md="8"
        sm="6"
        class="register-image right-column-container fixed-column"
        role="region"
        aria-label="Informacje dla kogo jest karta mieszkańca"
      >
        <v-card>
          <div class="v-card__title">
            <h2>
              Dla kogo jest Słupska Karta Mieszkańca?
            </h2>
          </div>

          <div class="v-card__description" role="region" aria-label="Informacje dla kogo jest Karta mieszkańca">
            Możesz otrzymać Słupską&nbsp;Kartę&nbsp;Mieszkańca jeśli

            <span class="font-bold d-inline">
              Twoim miejscem zamieszkania jest Miasto&nbsp;Słupsk i&nbsp;spełniasz jeden z&nbsp;poniższych wymogów:
            </span>

            <ol type="A" class="mt-2">
              <li>
                w&nbsp;deklaracji (PIT) za&nbsp;rok poprzedni wskazałeś/aś adres zamieszkania
                w&nbsp;Mieście&nbsp;Słupsk, nawet w&nbsp;przypadku, gdy nie&nbsp;wykazałeś/aś dochodów;
              </li>

              <li>
                jesteś członkiem rodziny osoby wymienionej powyżej, wspólnie zamieszkującym, ale&nbsp;nieosiągającym
                dochodów opodatkowanych:

                <ol type="A" class="my-2 clear-list">
                  <li>współmałżonkiem,</li>

                  <li>
                    dzieckiem do&nbsp;ukończenia 18&nbsp;roku&nbsp;życia, w&nbsp;przypadku kontynuacji nauki do
                    25&nbsp;roku&nbsp;życia,
                  </li>

                  <li>
                    dla której Sąd ustanowił opiekę&nbsp;prawną;
                  </li>
                </ol>
              </li>

              <li>otrzymujesz pomoc z&nbsp;Miejskiego Ośrodka Pomocy Rodzinie w&nbsp;Słupsku.</li>
            </ol>
          </div>
        </v-card>
      </v-col>
    </v-row>

    <material-dialog
      title="Twoje konto zostało zarejestrowane"
      text="Kliknij w link wysłany w wiadomości e-mail, żeby je potwierdzić."
      confirm-text="Ok"
      :show="showDialog"
      :show-cancel="false"
      :width="500"
      @confirm="redirectToLogin"
    />

    <popup />
  </div>
</template>

<script>
import { schemaMixin } from '@witkac/vuetify-components';

import HeaderSimple from '@/components/layout/HeaderSimple';
import MaterialDialog from '@/components/material/Dialog';
import Popup from '@/components/popup/Popup';
import RegisterForm from '@/components/forms/RegisterForm';
import TitleDecoration from '@/components/material/TitleDecoration';
import { notificationsMixin } from '@/mixins/notifications';
import schema from '@/schemas/register.schema';
import { serverError } from '@/utils/error';

// @vuese
// Formularz rejestracji
// @group Start
export default {
  components: { RegisterForm, HeaderSimple, MaterialDialog, Popup, TitleDecoration },
  mixins: [notificationsMixin, schemaMixin],
  schema,
  props: {
    source: String
  },
  data() {
    return {
      showPassword: false,
      showError: false,
      showDialog: false,
      errorMessage: undefined,
      model: {
        profile: {
          terc: '226301',
          simc: '0977278',
          type: 'CLIENT',
          woj: 'pomorskie',
          pow: 'powiat słupski',
          gmi: 'gmina miejska Słupsk',
          postalCode: '76-200'
        }
      }
    };
  },
  created() {
    const allTerms = this.$store.state.terms.current;
    const requiredTerms = allTerms.filter(terms => terms.required).map(terms => terms.id);
    this.$options.external = { requiredTerms };

    schema.properties.terms.properties = allTerms.reduce((properties, term) => {
      const key = 'term_' + term.id;
      properties[key] = {
        title: 'Zgoda',
        type: 'boolean',
        fieldRequired: term.required,
        validationMessages: {
          required: 'Zgoda musi zostać udzielona.'
        }
      };
      return properties;
    }, {});
    this.$setSchema(schema);
    // this.$schema.profile.street.$setFocus(true);
    // this.$schema.profile.street.$setFocus(false);
  },
  mounted() {
    this.$schema.profile.street.$dirty = true;
  },
  methods: {
    // @vuese
    // Funkcja rejestrująca użytkownika
    registerAccount() {
      // window.alert('ok');
      const errors = this.$schema.$validateAll();
      // console.log('errors', errors);
      this.valid = !errors.length;
      if (errors.length) {
        this.notifyError('Należy poprawić błędy formularza');
        this.scrollToError(errors[0]);
        return;
      }

      if (!this.$schema.$model.profile.street) {
        this.notifyError('Należy wypełnić ulicę');
        return;
      }

      this.$store
        .dispatch('profile/add', this.$schema.$getData())
        .then(() => (this.showDialog = true))
        .catch(error => this.notifyError('Nie udało się zarejestrować konta.', [serverError(error.message)]));
    },

    // @vuese
    // Przesuwa ekran do błędu
    scrollToError(error) {
      document.getElementById(error.$key).scrollIntoView();
      window.scrollBy({ top: -50 });
    },

    // @vuese
    // Przekierowuje na ekran logowania
    redirectToLogin() {
      this.$router.push({ name: 'login' });
    }
  }
};
</script>
